import { MenuItem, Select } from '@mui/material';
import React from 'react';
export const PositionSelect = ({ fullWidth, positions, selectedPosition, onSelectPosition, labelId, label, disabled, }) => {
    const handleSelectPosition = (e) => {
        if (e.target.value) {
            onSelectPosition(e.target.value);
        }
    };
    const onClick = (e) => {
        e.stopPropagation();
    };
    return (React.createElement(Select, { fullWidth: fullWidth, sx: { width: fullWidth ? undefined : '300px' }, label: label, onClick: onClick, labelId: labelId, onChange: handleSelectPosition, value: selectedPosition !== null && selectedPosition !== void 0 ? selectedPosition : '', disabled: disabled }, positions.map(({ positionName, positionId }) => (React.createElement(MenuItem, { value: positionId, key: positionId }, positionName)))));
};
